<template>
  <div class="public-attributes" v-if="attributes && attributes.length">
    <md-card class="md-card-unspaced public-attributes-card rfider-shadow">
      <md-card-content>
        <md-subheader
          class="public-attributes-card-header"
          v-if="attributesHeader"
          >{{ attributesHeader }}</md-subheader
        >
        <div
          v-for="(attr, index) in attributes"
          :key="index"
          class="md-layout md-alignment-center-center public-attributes-card-list"
        >
          <div class="md-layout-item md-size-40 public-attributes-label">
            {{ attr.label }}
          </div>
          <div class="md-layout-item md-size-60 public-attributes-value">
            {{ attr.value }}
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    attributesHeader: {
      type: String,
    },
  },
  data() {
    return {
      attributes: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(newVal) {
        const attrs = JSON.parse(JSON.stringify(newVal || [])).filter(
          (attr) => !!attr.publicEnabled,
        );

        attrs.sort((attr1, attr2) => attr1.publicOrder - attr2.publicOrder);

        this.attributes = attrs;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-attributes.scss';
</style>
